module.exports = __webpack_public_path__ + "img/88.1.19a31267.jpg";